import gql from 'graphql-tag';

export const CASE_ASSET_LOCATION_QUERY_NAME =
  'compositions_WithAssetLocationSearch_caseAssetLocationQuery';

const caseAssetLocationQuery = gql`
  query ${CASE_ASSET_LOCATION_QUERY_NAME} (
    $caseNumber: String!
    $distanceUnit: DistanceUnit,
  ) {
    case (caseNumber: $caseNumber) {
      id
      status
      assetLocation {
        countryCode
        coordinates {
          latitude
          longitude
        }
        highway
        mileMarker
        note
        searchValue
        address {
          city,
          country,
          postalCode,
          province,
          streetAddress,
        }
      }
      servicingDealer {
        id
        dealer {
          ...on Dealer { id }
          ...on CustomDealer { id }
        }
      }
      dealerTravelEstimateAtDispatch {
        distance(unit: $distanceUnit)
        time
      }
      statusHistory {
        id
        changedAt
        createdAt
        newStatus
        oldStatus
        user {
          email
          name
        }
      }
      proximityLevel
    }
  }
`;

export default caseAssetLocationQuery;



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerLocatorPanel/caseAssetLocationQuery.js